// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eGdd","clinicsSelect":"styles_clinicsSelect__3zhy4"};